import { useCallback, useState } from 'react';
import { Button, TextField } from '@mui/material';
import { useDialogFormReset } from '../../hooks/useDialogFormReset';
import { BaseDialog } from '../common';

type CreateLinkDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string, url: string) => void;
};

export const CreateLinkDialog = ({ open, onClose, onSubmit }: CreateLinkDialogProps) => {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const resetForm = useCallback(() => {
    setName('');
    setUrl('');
  }, []);
  const handleClose = useDialogFormReset(onClose, resetForm);

  const handleSubmit = () => {
    const linkName = name.trim();
    const linkUrl = url.trim();
    if (!linkName || !linkUrl) return;
    onSubmit(linkName, linkUrl);
    resetForm();
  };

  return (
    <BaseDialog
      open={open}
      onClose={handleClose}
      title="Create new link"
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={!name.trim() || !url.trim()}>
            Create
          </Button>
        </>
      }
    >
      <TextField
        autoFocus
        label="Link name"
        size="small"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
        sx={{ mt: 0.5 }}
      />
      <TextField
        label="URL"
        size="small"
        fullWidth
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSubmit();
        }}
        sx={{ mt: 2 }}
      />
    </BaseDialog>
  );
};
